/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';
import models, { ModelState } from './state/models';
import timeTravel, { TimeTravelState } from './state/time-travel';
import ui, { UiState } from './state/ui';
import sockets, { SocketState } from './sockets';

export * from './loaders';
export * from './state/ui';
export * from './state/models';
export * from './state/time-travel';

export interface State {
  models: ModelState;
  timeTravel: TimeTravelState;
  ui: UiState;
  sockets: SocketState;
}

export default combineReducers<State>({
  models,
  timeTravel,
  ui,
  sockets,
});
